"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAppCatalogFailedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "CreateAppCatalogFailed";
const messageKey = "plugins.spfx.createAppcatalogFail";
class CreateAppCatalogFailedError extends teamsfx_api_1.SystemError {
    constructor(error) {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
            message: (0, localizeUtils_1.getDefaultString)(messageKey, error.message, error.stack),
            displayMessage: (0, localizeUtils_1.getLocalizedString)(messageKey, error.message, error.stack),
        });
    }
}
exports.CreateAppCatalogFailedError = CreateAppCatalogFailedError;
//# sourceMappingURL=createAppCatalogFailedError.js.map